<!--
  StatusChip.vue

  Status pill used in the Stores list (and reusable elsewhere). Matches
  the design handoff palette: live/draft/pending/closed (archived reuses
  the neutral draft palette). Falls back to a
  neutral pill for any unknown status.
-->
<template>
    <span
        class="dist-status-chip"
        :class="`dist-status-chip--${variantKey}`"
        :data-testid="`status-chip-${variantKey}`"
    >
        {{ variant.label }}
    </span>
</template>

<script>
const VARIANTS = {
    live: { label: "Live" },
    draft: { label: "Draft" },
    pending: { label: "Pending" },
    closed: { label: "Closed" },
    archived: { label: "Archived" },
};
const UNKNOWN = { label: "Unknown" };

export default {
    name: "StatusChip",
    props: {
        status: { type: String, required: true },
    },
    computed: {
        variantKey() {
            return VARIANTS[this.status] ? this.status : "unknown";
        },
        variant() {
            return VARIANTS[this.status] || UNKNOWN;
        },
    },
};
</script>

<style scoped>
.dist-status-chip {
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.6px;
    padding: 3px 9px;
    border-radius: 9999px;
    text-transform: uppercase;
    line-height: 1.4;
}
.dist-status-chip--live {
    background: var(--tf-success-soft);
    color: var(--tf-success);
}
.dist-status-chip--draft,
.dist-status-chip--archived {
    background: #eef0f3;
    color: var(--tf-fg-4);
}
.dist-status-chip--pending {
    background: var(--tf-warning-soft);
    color: var(--tf-warning-dark);
}
.dist-status-chip--closed {
    background: var(--tf-error-soft);
    color: var(--tf-red);
}
.dist-status-chip--unknown {
    background: #eef0f3;
    color: var(--tf-fg-4);
}
</style>
